export function getCombatMovement(entity) {
    return Math.floor(entity.attributes.agility / 4);
}
export function getMaxHP(entity) {
    // **Hit Points (HP)** = base (3) + (Level × (Might + Resolve) / 4)
    return 3 + Math.floor(entity.level * (entity.attributes.might + entity.attributes.resolve) / 4);
}
export function getMaxMP(entity) {
    // **Mana Points (MP)** = base (3) + (Level × (Intellect + Resolve) / 4)
    return 3 + Math.floor(entity.level * (entity.attributes.intellect + entity.attributes.resolve) / 4);
}
export function getAttributeModifier(attributeValue) {
    return Math.floor(attributeValue / 2) - 5;
}
// Sums armor over the equipped item instances (resolve these from inventory by
// the character's equipment slot ids before calling).
export function getArmor(equippedItems) {
    return equippedItems.reduce((total, item) => total + (item.def.armor ?? 0), 0);
}
